import * as React from 'react'
import SummaryPrice from '../../common/components/summary-price'
import QuoteNumber from '../../common/components/quote-number'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import { get } from 'lodash'
import { Table, Row, Cell } from '../../common/components/summary-table'
import { toCurrency } from '../../common/util'
import { withConfig } from  '../../common/modules/config'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withState } from '../../common/modules/state'


export const formConfig = state => {
    return {
        rules: {
            propertyExcess: [],
            waterDamageExcess: []
        },
        predicates:{},
        options:{},
        inferred:{},
        transformOut: data => data,
    }
}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    
    componentWillMount(){

        const path = window.location.href;        

        if(this.props.fields.referred){
            const newPath = path+'?status=Referred'
            window.location.replace(newPath);
        }
        else if(this.props.fields.showPrice){
            const newPath = path + '?status=Quoted'
            window.location.replace(newPath);
        }
       else if(this.props.fields.indicativePrice){
            const newPath = path + '?status=IndicativePrice'
            window.location.replace(newPath);
        }

        if(this.props.fields.declined || this.props.fields.referred){
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3",
                "/step-4",
                "/step-5",
                "/step-6",
                "/step-7",
            ])
        }

        if(this.props.fields.declined){
            this.props.actions.navigation.changeRoute("/declined");
        }
    }


    updateExcess(field, value){
        console.log("Changed excess: " + field)
        console.log(value);
        this.props.actions.fields.updateField(field, value);

        const endpoint = this.props.submission.endpoints.flatQuote;
        this.props.actions.submission.submit(endpoint, null, [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
            require("./step-7").formConfig,
            require("./step-8").formConfig,
        ])
    }

    
    tick(field:string = null){
        return field == null || this.props.fields[field] == true
            ? <i className="fa fa-check-circle"></i>
            : null
    }


    render() {
        const fields = this.props.fields;
        const productData = this.props.productData;
        const lossOfRentAmount = fields.buildingSumInsured * (fields.lossOfRentPercent/100)
        const floodCoverValue = fields.floodCover == "OPTIONAL" ? (fields.floodCoverIncluded ? "Selected" : "Not insured") : "Required";

        return (
            <div className="row">
                <StepTitle>Here's The Cover You Requested</StepTitle>
                <QuoteNumber />

                <SubHeader>Your Protection Overview</SubHeader>

                <Table>

                    <Row highlight>
                        <Cell>{ this.tick() } Insured Property</Cell>
                        <Cell>Selected</Cell>
                    </Row>

                    <Row>
                        <Cell>Building</Cell><Cell>${ toCurrency(fields.buildingSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Contents</Cell><Cell>${ toCurrency(fields.contentsSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Loss of Rent/Temporary Accommodation (total payable)</Cell><Cell>${ toCurrency(lossOfRentAmount) }</Cell>
                    </Row>

                    { (get(fields, "ownersCorporationAddress.state") == "NSW" || get("fields", "ownersCorporationAddress.state") == "ACT") &&
                    <Row>
                        <Cell>Optional Lot/Unit Wall Coverings</Cell><Cell>{ fields.paintBenefit ? "Selected" : "Not insured" }</Cell>
                    </Row>
                    }

                    <Row>
                        <Cell>Flood Cover</Cell><Cell>{ floodCoverValue }</Cell>
                    </Row>

                    <Row>
                        <Cell>Property excess</Cell>
                        <Cell>
                            { !fields.referred &&
                            <select className="form-control"
                                value={ fields.propertyExcess }
                                onChange={e => this.updateExcess("propertyExcess", e.target.value) }>
                                { productData.excesses.Property.BUILDING.map(item => <option value={ parseInt(item.value) }>{ "$" + toCurrency(item.value) }</option>) }
                            </select>
                            }
                            { fields.referred &&
                                <span>${ toCurrency(fields.propertyExcess) }</span>
                            }
                        </Cell>
                    </Row>

                    <Row>
                        <Cell help="This Excess will apply to Section 1 – Insured Property if the loss or damage is caused by Water Damage as defined in the PDS.">Water damage excess</Cell>
                        <Cell>
                            { !fields.referred &&
                            <select className="form-control"
                                value={ fields.waterDamageExcess }
                                onChange={e => this.updateExcess("waterDamageExcess", e.target.value) }>
                                { productData.excesses.Property.WATER.map(item => <option value={ parseInt(item.value) }>{ "$" + toCurrency(item.value) }</option>) }
                            </select>
                            }
                            { fields.referred &&
                                <span>${ toCurrency(fields.waterDamageExcess) }</span>
                            }
                        </Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick() } Liability to others</Cell>
                        <Cell>Selected</Cell>
                    </Row>

                    <Row>
                        <Cell>Sum insured</Cell><Cell>${ toCurrency(fields.liabilitySumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Excess</Cell><Cell>${ toCurrency(fields.liabilityExcess) }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick("voluntaryWorkersRequired") } Voluntary Workers</Cell><Cell>{ fields.voluntaryWorkersRequired ? "Selected" : "Not insured" }</Cell>
                    </Row>

                    { fields.voluntaryWorkersRequired &&
                    <Row>
                        <Cell>Death</Cell><Cell>{ "$" + toCurrency(fields.voluntaryWorkersDeath) }</Cell>
                    </Row>
                    }

                    { fields.voluntaryWorkersRequired &&
                    <Row>
                        <Cell>Total Disablement</Cell><Cell>{ "$" + toCurrency(fields.voluntaryWorkersDisablementWeekly) } per week</Cell>
                    </Row>
                    }

                    <Row highlight>
                        <Cell>{ this.tick("workersCompensationRequired") } Workers Compensation</Cell><Cell>{ fields.workersCompensationRequired ? "Selected" : "Not insured" }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick("fidelityRequired") } Fidelity guarantee </Cell><Cell>{ fields.fidelityRequired ? "$" + toCurrency(fields.fidelitySumInsured) : "Not insured"}</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick("officeBearersRequired") } Office bearers legal liability </Cell><Cell>{ fields.officeBearersRequired ? "$" + toCurrency(fields.officeBearersSumInsured) : "Not insured" }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick("machineryBreakdownRequired") } Machinery breakdown </Cell><Cell>{ fields.machineryBreakdownRequired ? "$" + toCurrency(fields.machineryBreakdownSumInsured) : "Not insured" }</Cell>
                    </Row>


                    { fields.machineryBreakdownRequired && 
                    <Row>
                        <Cell>Machinery breakdown excess</Cell><Cell>${ toCurrency(fields.machineryBreakdownExcess) }</Cell>
                    </Row>
                    }

                    { fields.machineryBreakdownRequired && 
                    <Row>
                        <Cell>Machinery Breakdown chiller excess</Cell><Cell>{ fields.chillersOrCoolingTowers ? "$" + toCurrency(fields.machineryBreakdownChillerExcess) : "Not insured" }</Cell>
                    </Row>
                    }

                    <Row highlight>
                        <Cell>{ this.tick("catastropheRequired") } Catastrophe insurance</Cell><Cell>{ !fields.catastropheRequired && "Not insured" }</Cell>
                    </Row>

                    { fields.catastropheRequired &&
                    <Row>
                        <Cell>Catastrophe Sum Insured</Cell><Cell>${ toCurrency(fields.catastropheSumInsured) }</Cell>
                    </Row>
                    }

                    { fields.catastropheRequired &&
                    <Row>
                        <Cell>Extended cover - Rent/Temporary Accommodation</Cell><Cell>${toCurrency( fields.catastropheExtendedCoverRentTemporaryAccomodation) }</Cell>
                    </Row>
                    }

                    { fields.catastropheRequired &&
                    <Row>
                        <Cell>Escalation in Cost of Temp Accommodation</Cell><Cell>${ toCurrency(fields.catastropheEscalationTemporaryAccomodation) }</Cell>
                    </Row>
                    }

                    { fields.catastropheRequired &&
                    <Row>
                        <Cell>Cost or Removal, Storage and Evacuation</Cell><Cell>${ toCurrency(fields.catastropheStorageEvacuation) }</Cell>
                    </Row>
                    }


                    <Row highlight>
                        <Cell>{ this.tick("governmentAuditIncluded") } Government Audit Costs and Legal Expenses</Cell>
                        <Cell>{ fields.governmentAuditIncluded ? "Selected" : "Not Insured" }</Cell>
                    </Row>

                    <Row show={ fields.governmentAuditIncluded }>
                        <Cell>Government Audit Costs</Cell><Cell>${ toCurrency(fields.gaGovernmentAuditSumInsured) }</Cell>
                    </Row>

                    <Row show={ fields.governmentAuditIncluded }>
                        <Cell>Appeal expenses - common property health &amp; safety breaches</Cell><Cell>${ toCurrency(fields.gaAppealExpensesSumInsured) }</Cell>
                    </Row>

                    <Row show={ fields.governmentAuditIncluded }>
                        <Cell>Legal Defence Expenses</Cell><Cell>${ toCurrency(fields.gaLegalDefenceExpensesSumInsured) }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>{ this.tick("lotOwnersIncluded") } Lot owners' fixtures and improvements (per lot)</Cell>
                        <Cell>{ fields.lotOwnersIncluded ?  "Selected" : "Not Insured" }</Cell>
                    </Row>

                    <Row show={ fields.lotOwnersIncluded }>
                        <Cell>Lot owners' Sum Insured</Cell>
                        <Cell>${ toCurrency(fields.lotOwnersSumInsured) }</Cell>
                    </Row>
                </Table>
                
                <SummaryPrice 
                    referred = { fields.referred }
                    totalPayable = { fields.totalPayable }
                    basePremium = { fields.basePremium }
                    levies = { fields.levies }
                    gst = { fields.gst }
                    stampDuty = { fields.stampDuty }
                    adminFee = { fields.adminFee }
                    brokerFee = { fields.brokerFee }
                    commission = { fields.commission }
                    commissionGst = { fields.commissionGst }
                    summaryText = { fields.summaryText }
                    actions = { this.props.actions }
                    indicativePrice = {fields.indicativePrice}
                    indicativePriceText = {fields.indicativePriceText}
                />

                <Button.Container show={ fields.referred == false} >
                    <Button.Back route="/step-7" /> <Button.Save onClick={ this.save.bind(this) }/> <Button.BuyNow onClick={ this.proceed.bind(this)} />
                </Button.Container>
            </div>
        )
    }


    save(){
        this.props.actions.submission.save("/step-8", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
            require("./step-7").formConfig,
            require("./step-8").formConfig,
        ]);
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/payment");
    }


}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-8.tsx